import AppLayout from '@/pages/layout/index';
import Home from '@/pages/home';
import Bank from '@/pages/bank/List';
import Guarantee from '@/pages/guarantee/Detail';
import Insurance from '@/pages/insurance/List';
import About from '@/pages/about';
import Login from '@/pages/login';
import BankDetail from '@/pages/bank/Detail';
import BankApplication from '@/pages/bank/Application';
import InsuranceDetail from '@/pages/insurance/Detail';
import GuaranteeApplication from '@/pages/guarantee/Application';

import Result from '@/pages/result';
import Register from '@/pages/register';
import Callback from '@/pages/callback';
import User from '@/pages/user';
import MyApplication from '@/pages/myApplication/List';
import MyApplicationDetail from '@/pages/myApplication/Detail';
import Mechanism from '@/pages/home/Mechanism';
import Authentication from '@/pages/authentication';
import MajorFinancing from '@/pages/majorFinancing/Main';
import MajorFinancingApplication from '@/pages/majorFinancing/Application';
import Capital from '@/pages/capital/List';
import CapitalDetail from '@/pages/capital/Detail';
import FacilityLoan from '@/pages/facilityLoan';
import FacilityLoanDetail from '@/pages/facilityLoan/Detail';
import FacilityLoanApplication from '@/pages/facilityLoan/Application';

import IndustryBankLoan from '@/pages/industryBankLoan';
import IndustryBankLoanDetail from '@/pages/industryBankLoan/Detail';
import IndustryBankLoanApplication from '@/pages/industryBankLoan/Application';

import CreditGuarantee from '@/pages/creditGuarantee';
import CreditGuaranteeDetail from '@/pages/creditGuarantee/Detail';
import CreditGuaranteeApplication from '@/pages/creditGuarantee/Application';

import SpecialOffer from '@/pages/specialOffer/List';
import SpecialOfferApplication from '@/pages/specialOffer/Application';

import Policy from '@/pages/policyNotice/policy/List';
import PolicyDetail from '@/pages/policyNotice/policy/Detail';
import Notice from '@/pages/policyNotice/notice/List';
import NoticeDetail from '@/pages/policyNotice/notice/Detail';

import AgriculturalSubsidies from '@/pages/agriculturalSubsidies';
import AgriculturalSubsidiesDetail from '@/pages/agriculturalSubsidies/Detail';
import AgriculturalSubsidiesApplication from '@/pages/agriculturalSubsidies/Application';

import LargeGrainGrower from '@/pages/largeGrainGrower';
import LargeGrainGrowerDetail from '@/pages/largeGrainGrower/Detail';
import LargeGrainGrowerApplication from '@/pages/largeGrainGrower/Application';

import TransformationFinancing from '@/pages/transformationFinancing/Main';
import TransformationFinancingApplication from '@/pages/transformationFinancing/Application';

import AgrProductProcessingProjects from '@/pages/projectScheduling/agrProductProcessingProjects';
import HundredBillionAgrProject from '@/pages/projectScheduling/hundredBillionAgrProject';
import ProjectSchedulingList from '@/pages/projectScheduling/myProject';
import ProjectSchedulingMyProjectDetail from '@/pages/projectScheduling/myProject/components/Detail';

import SupplyChainFinanceHome from '@/pages/supplyChainFinance/home';
import SupplyChainFinanceProjectSelect from '@/pages/supplyChainFinance/projectSelect';
import SupplyChainFinanceApplication from '@/pages/supplyChainFinance/application';
import SupplyChainFinanceFinancingApplication from '@/pages/supplyChainFinance/financingApplication';
import SupplyChainRelationshipConfirm from '@/pages/supplyChainFinance/relationshipConfirm';
import SupplyChainRelationshipConfirmDetail from '@/pages/supplyChainFinance/relationshipConfirm/components/Detail';
import SupplyChainFinanceDeclaration from '@/pages/supplyChainFinance/declaration';
import SupplyChainDeclareResult from '@/pages/supplyChainFinance/declareResult';
import SupplyChainInsuranceApplication from '@/pages/supplyChainFinance/insuranceApplication';

export const routers = [
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { path: '/home', element: (<Home />) },
      { path: '/bank', element: (<Bank />) },
      { path: '/guarantee', element: (<Guarantee />) },
      { path: '/insurance', element: (<Insurance />) },
      { path: '/about', element: (<About />) },
      { path: '/result', element: (<Result />) },
      { path: '/bank/detail', element: (<BankDetail />) },
      { path: '/bank/application', element: (<BankApplication />) },
      { path: '/insurance/detail', element: (<InsuranceDetail />) },
      { path: '/guarantee/application', element: (<GuaranteeApplication />) },
      { path: '/user', element: (<User />) },
      { path: '/myApplication', element: (<MyApplication />) },
      { path: '/myApplication/detail', element: (<MyApplicationDetail />) },
      { path: '/home/mechanism', element: (<Mechanism />) },
      { path: '/authentication', element: (<Authentication />) },
      { path: '/majorFinancing', element: (<MajorFinancing />) },
      { path: '/majorFinancing/application', element: (<MajorFinancingApplication />) },
      { path: '/capital', element: (<Capital />) },
      { path: '/capital/detail', element: (<CapitalDetail />) },
      { path: '/facilityLoan', element: (<FacilityLoan />) },
      { path: '/facilityLoan/detail', element: (<FacilityLoanDetail />) },
      { path: '/facilityLoan/application', element: (<FacilityLoanApplication />) },

      { path: '/industryBankLoan', element: (<IndustryBankLoan />) },
      { path: '/IndustryBankLoan/detail', element: (<IndustryBankLoanDetail />) },
      { path: '/industryBankLoan/application', element: (<IndustryBankLoanApplication />) },

      { path: '/creditGuarantee', element: (<CreditGuarantee />) },
      { path: '/creditGuarantee/detail', element: (<CreditGuaranteeDetail />) },
      { path: '/creditGuarantee/application', element: (<CreditGuaranteeApplication />) },

      { path: '/specialOffer', element: (<SpecialOffer />) },
      { path: '/specialOffer/detail', element: (<BankDetail />) },

      { path: '/agriculturalSubsidies', element: (<AgriculturalSubsidies />) },
      { path: '/agriculturalSubsidies/detail', element: (<AgriculturalSubsidiesDetail />) },
      { path: '/agriculturalSubsidies/application', element: (<AgriculturalSubsidiesApplication />) },
      { path: '/policy', element: (<Policy />) },
      { path: '/policy/detail', element: (<PolicyDetail />) },
      { path: '/notice', element: (<Notice />) },
      { path: '/notice/detail', element: (<NoticeDetail />) },
      { path: '/specialOffer/application', element: (<SpecialOfferApplication />) },

      { path: '/largeGrainGrower', element: (<LargeGrainGrower />) },
      { path: '/largeGrainGrower/detail', element: (<LargeGrainGrowerDetail />) },
      { path: '/largeGrainGrower/application', element: (<LargeGrainGrowerApplication />) },

      { path: '/transformationFinancing', element: (<TransformationFinancing />) },
      { path: '/transformationFinancing/application', element: (<TransformationFinancingApplication />) },

      { path: '/projectScheduling/agrProductProcessingProjects', element: (<AgrProductProcessingProjects />) },
      { path: '/projectScheduling/hundredBillionAgrProject', element: (<HundredBillionAgrProject />) },
      { path: '/projectScheduling/myProject', element: (<ProjectSchedulingList />) },
      { path: '/projectScheduling/myProject/detail', element: (<ProjectSchedulingMyProjectDetail />) },

      { path: '/supplyChain/home', element: (<SupplyChainFinanceHome />) },
      { path: '/supplyChain/project', element: (<SupplyChainFinanceProjectSelect />) },
      { path: '/supplyChain/application', element: (<SupplyChainFinanceApplication />) },
      { path: '/supplyChain/financingApplication', element: (<SupplyChainFinanceFinancingApplication />) },
      { path: '/supplyChain/relationshipConfirm', element: (<SupplyChainRelationshipConfirm />) },
      { path: '/supplyChain/detail', element: (<SupplyChainRelationshipConfirmDetail />) },
      { path: '/supplyChain/declaration', element: (<SupplyChainFinanceDeclaration />) },
      { path: '/supplyChain/declareResult', element: (<SupplyChainDeclareResult />) },
      { path: '/supplyChain/insuranceApplication', element: (<SupplyChainInsuranceApplication />) },
    ],
  },
  {
    path: '/login',
    element: (<Login />),
  },
  { path: '/register', element: (<Register />) },
  { path: '/callback', element: (<Callback />) },
];
